import { OperationType } from '../types/interfaces';

export const OperationTypesTemplate: OperationType = {
  id: '',
  operationName: '',
  measure: undefined,
  measureName: ''
};
